import {
  useGetWorkspaceFoldersQuery,
  useMoveRecordingMutation,
} from '@carboncopyco/data';
import type { IRecording } from '@carboncopyco/types';
import { notify } from '@carboncopyco/ui';

import { MoveAssetModal } from '../../../MoveAssetModal';

type MovCloneModalProps = {
  onClose: () => void;
  clone: IRecording;
  organizationId: string;
  workspaceId: string;
};

export const MoveCloneModal = ({
  onClose,
  clone,
  organizationId,
  workspaceId,
}: MovCloneModalProps) => {
  const [moveClone, { isLoading }] = useMoveRecordingMutation();
  const { data: folders } = useGetWorkspaceFoldersQuery({
    organizationId,
    workspaceId,
  });
  const cloneFolderId = String(clone.folderId);

  return (
    <MoveAssetModal
      close={onClose}
      origin={{
        id: cloneFolderId,
        workspaceId,
        entity: cloneFolderId === '0' ? 'workspace' : 'folder',
      }}
      onSubmit={(targetFolderId) => {
        moveClone({
          organizationId,
          targetFolderId: targetFolderId,
          id: clone.id,
          currentFolderId: cloneFolderId,
          workspaceId,
        })
          .unwrap()
          .then(() => {
            const folderName = folders.find(
              (folder) => String(folder.id) === targetFolderId
            )?.name;
            notify.success(
              `Clone successfully moved to ${targetFolderId === '0' ? 'workspace' : folderName}`
            );
          })
          .catch((error) => notify.error(error.data.message))
          .finally(onClose);
      }}
      blockOtherWorkspaces
      isLoading={isLoading}
      tooltipText="This asset cannot be moved between workspaces at the moment, but it will be supported soon!"
    />
  );
};
